/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import styled from 'styled-components';

import { BreakPoint, Color, FontSize } from '../../../../../asset/styles';
import { check } from '../../../../../asset/images';
import { Checkbox } from '../../../../../../common/primitive';

const StyledDiv = styled.div`
  position: relative;
  margin: 12px 0 0;

  > input {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
  }

  > input + label {
    box-sizing: border-box;
    display: block;
    position: relative;
    width: 100%;
    padding-left: 40px;
    color: ${Color.text.gray};
    font-size: ${FontSize.medium};
    line-height: 1.6875;
    min-height: 1.6875em;
    -webkit-text-size-adjust: 100%;

    @media (min-width: ${BreakPoint.desktop}) {
      font-size: ${FontSize.desktop.small};
      padding-left: 26px;
      cursor: pointer;
    }

    @media (max-width: ${BreakPoint.small}) {
      font-size: ${FontSize.smallDevice.medium};
    }

    &:before {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      border: solid 2px ${Color.border.gray};
      border-radius: 4px;
      box-sizing: border-box;
      cursor: pointer;
      margin-right: 16px;
      height: 24px;
      width: 24px;

      @media (min-width: ${BreakPoint.desktop}) {
        height: 18px;
        width: 18px;
        margin-top: 3px;
        margin-right: 8px;
      }
    }
  }

  > input:checked + label {
    color: ${Color.text.darkGray};

    &:before {
      background: ${Color.border.blue} url(${check.white}) no-repeat center
        center / 12px 9px;
      border-color: ${Color.border.blue};
    }
  }
`;

/**
 * {@link Inquiry} 設問 checkbox component
 * @param {string} id unique id - label / checkbox 紐づけます
 * @param {string} label label text
 * @param {string} name form input[name] に使用します
 * @param {string} value form input[value] に使用します
 * @param {*} props React.props
 * @return {*} React.node - {@link Inquiry} 設問 checkbox
 * @constructor
 */
const BodyCheckboxWithLabel = ({ id, label, name, value, ...props }) => (
  // !console.log('BodyCheckboxes label / props', label, props) &&
  <StyledDiv className={'CheckboxWithLabel'}>
    <Checkbox id={id} name={name} value={value} />
    <label htmlFor={id}>
      <span style={{ wordBreak: 'break-all', display: 'inline-block' }}>
        {label}
      </span>
    </label>
  </StyledDiv>
);

export default BodyCheckboxWithLabel;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/body/checkboxes/BodyCheckboxWithLabel.js